export const actionTypes = {
  TOTAL_PAYMENTS_REQUEST: 'TOTAL_PAYMENTS_REQUEST',
  TOTAL_PAYMENTS_SUCCESS: 'TOTAL_PAYMENTS_SUCCESS',
  TOTAL_PAYMENTS_FAILURE: 'TOTAL_PAYMENTS_FAILURE',
  PAYMENTS_LIST_REQUEST: 'PAYMENTS_LIST_REQUEST',
  PAYMENTS_LIST_SUCCESS: 'PAYMENTS_LIST_SUCCESS',
  PAYMENTS_LIST_FAILURE: 'PAYMENTS_LIST_FAILURE',
  UPDATE_DISPUTE_SUCCESS: 'UPDATE_DISPUTE_SUCCESS',
  GENERATE_REPORT_REQUEST: 'GENERATE_REPORT_REQUEST',
  GENERATE_REPORT_SUCCESS: 'GENERATE_REPORT_SUCCESS',
  GENERATE_REPORT_FAILURE: 'GENERATE_REPORT_FAILURE',
  RESET_GENERATE_REPORT: 'RESET_GENERATE_REPORT',
};
